<template>
    <div class="container mb-5">

       <div class="card rounded">
           <div class="card-header text-center">
               <h3>Council <span class="text-primary">Members</span></h3>
               <p>
                   To contact RGEA HOSA's council members, please send an email by clicking here 
               </p>
               <a target="_blank" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=council@rgeahosa.org">
                 council@rgeahosa.org
               </a>
           </div>
           <div class="card-body">
               
                <div class="form-group">
                    <select class="form-select" v-model="comID" @change="getAllCommittee()">
                        <option value="">Select Committee</option>
                        <option v-for="com in committees" :value="com.id" :key="com.id">
                          {{ com.name }}
                        </option>
                    </select>
                </div>
                <hr>
                <div class="row">
                     
                    <div class="col-lg-4 mb-4 mb-lg-0" v-for="coun in paginated" :key="coun.id">
                        <div class="shadow-sm box mb-4 text-center">
                            <div class="p-3 border bg-white">
                                <h3 class="h5">
                                  <a class="reset-anchor" href="#">
                                    {{ coun.name }}
                                  </a>
                                </h3>
                                <p class="text-small text-muted">
                                    <span>{{ coun.post }}</span> <br>
                                    <!-- <span>{{ coun.email }}</span> <br>
                                    <span>{{ coun.phone }}</span> -->
                                </p>
                            </div>
                        </div>
                    </div>

               </div>
           </div>
           <div class="card-footer text-center">
                <nav class="myNav hidden-xs" aria-label="Page navigation">
                    <ul class="pagination">
                        <li v-bind:class="[{disabled: !pagination.prevPage }]" class="active">
                            <a href="#" class="page-link" @click.prevent="substraction()">
                                <b>Previous</b>
                            </a>
                        </li>

                        <li class="page-item disabled">
                            <a class="page-link " href="#" style="color: black">
                                Page
                                <b>{{ pagination.currentPage }}</b>
                                of
                                <b>{{ pagination.page }}</b>
                            </a>
                        </li>

                        <li v-bind:class="[{disabled: !pagination.nextPage }]" class="active">
                            <a href="#" class="page-link" @click.prevent="addition()">
                                <b>Next</b>
                            </a>
                        </li>

                        <li class="page-item disabled">
                            <a class="page-link" href="#" style="color: black"> From
                                <b>{{ pagination.from}}</b> to
                                <b>{{ pagination.to}}</b> out of
                                <b>{{ pagination.total }}</b>
                            </a>
                        </li>
                    </ul>
                </nav>
           </div>
       </div>

    </div>
</template>
<script>
import CouncilServices from "../../services/CouncilServices";
export default {
    data() {
        return {
            counsils:[],
            committees:[],
            comID:'',
            pagination:{
                currentPage:1,
                nextPage:'',
                prevPage:'',
                total:'',
                from:'',
                to:'',
                page:'',
           },
           length:12, 
        }
    },

    mounted() {
        this.getCouncils().then((res)=>{
          this.counsils = res.data.data;
        });

        this.getCom().then((res) => {
          this.committees = res.data.data;
        });
    },

    methods:{
           
        getAllCommittee(){
           if(this.comID !== ""){
                this.counsils = [];
                this.getCommitteeSelected(this.comID).then((res) => {
                    this.counsils = res.data.data;
                });
           } else {
                this.getCouncils().then((res)=>{
                    this.counsils = res.data.data;
                });
           }
        },

        async getCouncils(){
            try{
                const responce = await CouncilServices.getCouncil();
                return responce;
            } catch (e) {
                return e;
            }
        },

        async getCom(){
            try{
                const responce = await CouncilServices.getCommittee();
                return responce;
            } catch (e) {
                return e;
            }
        },

        async getCommitteeSelected(id){
            try{
                const responce = await CouncilServices.getFilters(id);
                return responce;
            } catch (e) {
                return e;
            }
        },


        substraction(){
            if(this.pagination.currentPage <=  1){
                this.$toast.fire('Page Limit :', 'Sorry cant go further', 'warning');
            } else {
                --this.pagination.currentPage;
            }
        },

        addition(){
            if(this.pagination.currentPage == this.pagination.page){
                this.$toast.fire('Page Limit :', 'Sorry cant go further', 'warning');
            } else {
                ++this.pagination.currentPage;
            }
        },

        paginate(array, length, pageNumber){
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            this.pagination.page = Math.ceil(array.length / length);
            this.pagination.total = array.length;

            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },

        resetPagination(){
            this.pagination.currentPage  = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
    },

    computed: {
        filteredCounsil(){
            return this.counsils;
        },

        paginated(){
            return this.paginate(this.filteredCounsil, this.length, this.pagination.currentPage);
        },
    },
}
</script>
<style lang="scss" scoped>

.myNav ul {
    text-align:center;
    position: relative;
    display: inline-flex;
}

.form-select {
    padding-left: 20px;
    font-size: 1rem;
    height: 50px;
    width: 100%;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 2px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

</style>